import type { VideoStateMetrics } from '../../core/types';

const NETWORK_STATE_LABELS: Record<number, string> = {
  0: 'NETWORK_EMPTY',
  1: 'NETWORK_IDLE',
  2: 'NETWORK_LOADING',
  3: 'NETWORK_NO_SOURCE',
};

const READY_STATE_LABELS: Record<number, string> = {
  0: 'HAVE_NOTHING',
  1: 'HAVE_METADATA',
  2: 'HAVE_CURRENT_DATA',
  3: 'HAVE_FUTURE_DATA',
  4: 'HAVE_ENOUGH_DATA',
};

export function buildVideoStateMetrics(
  video: HTMLVideoElement,
  eventType: 'waiting' | 'stalled',
  src: string | undefined,
  quality: string | undefined,
): VideoStateMetrics {
  const bufferedRanges: Array<{ start: number; end: number }> = [];
  for (let i = 0; i < video.buffered.length; i++) {
    bufferedRanges.push({ start: video.buffered.start(i), end: video.buffered.end(i) });
  }

  const metrics: VideoStateMetrics = {
    currentTime: video.currentTime,
    paused: video.paused,
    seeking: video.seeking,
    bufferLength: Math.max(0, (bufferedRanges.find(range =>
      range.start <= video.currentTime && range.end >= video.currentTime,
    )?.end ?? video.currentTime) - video.currentTime),
    src,
    quality,
    duration: isFinite(video.duration) ? video.duration : 0,
    networkState: video.networkState,
    networkStateDescription: NETWORK_STATE_LABELS[video.networkState] ?? 'Unknown',
    readyState: video.readyState,
    readyStateDescription: READY_STATE_LABELS[video.readyState] ?? 'Unknown',
    bufferedRanges,
  };

  if (eventType === 'waiting' && bufferedRanges.length > 0) {
    const lastBufferedEnd = bufferedRanges[bufferedRanges.length - 1].end;
    metrics.bufferTime = lastBufferedEnd - video.currentTime;
  }

  return metrics;
}
